import { useEffect, useState } from "react";
import type { IEdition } from "../../types";

const SESSION_JOIN_ANTICIPATION_MS = 3600000;

export function useCurrentEditionSession(enrolledEdition: IEdition | undefined) {
  const [isCurrentSession, setIsCurrentSession] = useState<boolean>(false);
  const [currentLink, setCurrentLink] = useState<string>();

  useEffect(() => {
    const now = Date.now();

    const currentSession = enrolledEdition?.sessions
      ?.slice()
      .sort((a, b) => a.startDate - b.startDate)
      .find((session) => now >= session.startDate - SESSION_JOIN_ANTICIPATION_MS && now <= session.endDate);

    if (currentSession) {
      setIsCurrentSession(true);
      setCurrentLink(currentSession.link ?? undefined);
    } else {
      setIsCurrentSession(false);
      setCurrentLink(undefined);
    }
  }, [enrolledEdition]);

  return { currentLink, isCurrentSession };
}
